import React from 'react';

const TYPE_CONFIG = {
  company:    { label: 'COMPANY',    className: 'research-badge-company' },
  product:    { label: 'PRODUCT',    className: 'research-badge-product' },
  regulation: { label: 'REGULATION', className: 'research-badge-regulation' },
  term:       { label: 'TERM',       className: 'research-badge-term' },
  person:     { label: 'PERSON',     className: 'research-badge-person' },
  topic:      { label: 'TOPIC',      className: 'research-badge-topic' },
};

export default function ResearchPanel({ items, loading }) {
  if ((!items || items.length === 0) && !loading) return null;

  return (
    <div className="research-panel">
      <div className="research-header">
        <span>Research Assistant</span>
        {loading && <span className="research-loading-indicator" />}
      </div>
      <div className="research-list">
        {items.map((item, i) => {
          const cfg = TYPE_CONFIG[item.type] || TYPE_CONFIG.topic;
          return (
            <div key={`${item.subject}-${i}`} className="research-card">
              <div className="research-card-header">
                <span className={`research-badge ${cfg.className}`}>{cfg.label}</span>
                <span className="research-subject">{item.subject}</span>
                {item.webEnriched && <span className="research-web-tag" title="Enriched with web search">WEB</span>}
              </div>
              <div className="research-insight">{item.insight}</div>
            </div>
          );
        })}
        {loading && items.length === 0 && (
          <div className="research-searching">Researching topics...</div>
        )}
      </div>
    </div>
  );
}
